// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"194":"3bd054","371":"58e777"}[chunkId] + ".css";
};